/**
 * hemēka · menu de l'en-tête et tiroir panier ouvert (repris de pop-tiroir-menu.js, pop-cbd, 15/10/2026).
 *
 * Sur ordinateur, le tiroir panier s'ouvre en colonne et la page rétrécit à côté : le menu n'a plus la
 * place, des entrées passent dans « Plus », dont le panneau n'affiche pas nos sous-menus et dont les
 * liens ne répondent pas.
 * 1. Quand la souris arrive sur le menu alors que le tiroir est ouvert, on ferme le tiroir.
 * 2. Défaut d'Horizon : une fois le tiroir fermé, la page reprend sa largeur mais le menu reste replié
 *    dans « Plus » (overflow-list n'observe que sa propre taille). On le force à se recalculer : il
 *    réagit à l'ajout d'un enfant (MutationObserver).
 * Ne touche ni au tiroir ni au menu d'Horizon : on écoute le pointeur et la fermeture du tiroir.
 */
const recalculerMenu = () => {
  for (const liste of document.querySelectorAll('header overflow-list')) {
    const temoin = document.createElement('span');
    temoin.hidden = true;
    liste.appendChild(temoin);
    setTimeout(() => temoin.remove(), 50);
  }
};

document.addEventListener(
  'pointerover',
  (event) => {
    if (event.pointerType === 'touch') return;
    const cible = event.target instanceof Element ? event.target : null;
    if (!cible?.closest('header header-menu, header .menu-list')) return;
    const tiroir = /** @type {any} */ (document.getElementById('cart-drawer'));
    if (!tiroir?.querySelector('dialog')?.open) return;
    tiroir.close?.();
  },
  { passive: true }
);

// L'événement « close » d'un <dialog> ne remonte pas : on l'écoute en phase de capture.
document.addEventListener(
  'close',
  (event) => {
    if (!(event.target instanceof HTMLDialogElement) || !event.target.closest('#cart-drawer')) return;
    recalculerMenu();
    setTimeout(recalculerMenu, 450);
  },
  true
);
